import { GenerateDriveTimeReportPdfInput, GeneratedDocumentPdf, GeneratedDocumentStatusEnum } from '@/models/gen/graphql';

import { GenerateDriveTimeReportPdfDocument } from '@/api/queries';
import downloadDriveTimeReportPDF from '@/features/DriveTimeTool/api/services/downloadDriveTimeReportPDF';
import graphApi from '@/api';
import searchGeneratedDocuments from '@/api/services/pdf/searchGeneratedDocuments';
import { sleep } from '@/utils';

const [, runRefetchGenerateDriveTimeReportPDF] = graphApi(GenerateDriveTimeReportPdfDocument);

const generateDriveTimeReportPDF = async (queryHistoryId: string, manifestHistoryRouteId?: string): Promise<GeneratedDocumentPdf> => {
  const input: GenerateDriveTimeReportPdfInput = { queryHistoryId, manifestHistoryRouteId };
  const res = await runRefetchGenerateDriveTimeReportPDF({ input });
  return res?.generateDriveTimeReportPDF?.generatedDocument;
};

export const generateAndDownloadDriveTimePDF = async (queryHistoryId: string, manifestHistoryRouteId?: string): Promise<void> => {
  const res = await generateDriveTimeReportPDF(queryHistoryId, manifestHistoryRouteId);
  // check document status here
  while (true) {
    const [generatedDocument] = await searchGeneratedDocuments(res?.id || '');
    if (generatedDocument?.status === GeneratedDocumentStatusEnum.Completed) {
      await downloadDriveTimeReportPDF(generatedDocument.fileLocation);
      break;
    }
    if (generatedDocument?.status === GeneratedDocumentStatusEnum.Failed) {
      throw new Error('Failed to generate PDF. Please try again.');
    }
    await sleep(1000); // wait 1 second before next poll
  }
};

export default generateDriveTimeReportPDF;
